import $ from 'jquery';

(($) => {
  class ContactForm {
    constructor(config) {
      this.config = {
        $jsonData: $('[data-id="contact-form-data"]'),
        placeholderCountryCode: '',
        userCountryCode: '',
        disableScrolling: false,
        backButtonClass: '.js_contact-form-back',
        contactFormClass: '.js_contact-form',
        contactFormModalId: '#modal-contact-form',
        headlineClass: '.js_contact-form-headline',
        iframeClass: '.js_contact-form-iframe',
        iframeWrapperClass: '.js_contact-form-iframe-wrapper',
        jsonData: null,
        linkClass: '.js_contact-form-link',
        modalHeadlineClass: '.js_contact-form-modal-headline',
        subheadlineClass: '.js_contact-form-subheadline',
        selectClass: '.js_contact-form-select',
        modalClass: '.modal',
        contentContainerClass: '.container-fluid',
        ...config,
      };

      const modalsReady = document.querySelector('body').classList.contains('modals-ready');

      if (modalsReady) {
        this.init();
        this.events();
      } else {
        window.addEventListener('modal-third-party-notification-ready', () => {
          this.init();
          this.events();
        });
      }
    }

    init() {
      const { contactFormClass } = this.config;

      const formHeadline = $(contactFormClass).data('contact-form-headline') || '';
      const modalHeadline = $(contactFormClass).data('contact-form-modal-headline') || '';

      this.setHeadline(formHeadline);
      this.setModalHeadline(modalHeadline);
      this.parseFormData();
      // this.fetchUserCountryCode();
      this.openCategoryFromQuery();
    }

    events() {
      const { backButtonClass } = this.config;

      $(backButtonClass).on('click', (e) => this.goBack(e));
      $('body').on('click', (e) => this.openCategoryInModal(e));
      this.categoryClickEvents();
    }

    categoryClickEvents() {
      const { linkClass, modalClass, contentContainerClass } = this.config;

      $(linkClass).each((index, category) => {
        const $category = $(category);
        const $anchor = $category.find('a.link');
        const anchorHref = $anchor.attr('href');
        const parentClass = $category.parents(modalClass).length ? modalClass : contentContainerClass;

        if ($anchor && !anchorHref) {
          $category.on('click', (e) => this.openCategory(e, parentClass));
        }
      });
    }

    parseFormData() {
      const { $jsonData } = this.config;

      if ($jsonData && $jsonData.text()) {
        this.config.jsonData = JSON.parse($jsonData.text());
      }
    }

    fetchUserCountryCode() {
      const countryCodeUrl = this.config.$jsonData.data('url-country-code');
      // get json data from the url
      fetch(countryCodeUrl)
        .then((response) => response.json())
        .then((data) => {
          // extract required variables
          this.config.placeholderCountryCode = data.replaceSource;
          this.config.userCountryCode = data.replaceString;
        })
        .catch((error) => {
          // error log
          console.error('Error fetching data:', error);
        });
    }

    setFormContactReason(reason) {
      window.adobeDataLayer = window.adobeDataLayer || [];
      window.adobeDataLayer.push({ component: { form: { contactReason: reason } } });
    }

    populateSelect(categoryKey, parentClass) {
      const { selectClass, jsonData } = this.config;
      const $select = $(`${parentClass} ${selectClass}`).find('select');
      const $defaultOption = $(`<option value="default">${$select.data('default-option') || ''}</option>`);

      if (!categoryKey || !$select || !jsonData || !jsonData[categoryKey]) {
        return;
      }

      $select.empty();
      $select.append($defaultOption);
      this.setFormContactReason(null);

      if (jsonData[categoryKey].length > 1) {
        jsonData[categoryKey].forEach((link) => {
          const replacedSrc = link.src.replace(this.config.placeholderCountryCode, this.config.userCountryCode);
          const $option = $(
            `<option value="${replacedSrc || '/'}" data-reason="${link.reason || ''}">${link.text ? link.text : replacedSrc ? replacedSrc : 'Missing text in JSON.'}</option>`
          );
          $select.append($option);
        });

        this.showSelect();
      } else if (jsonData[categoryKey][0] && jsonData[categoryKey][0].src) {
        this.emptyIFrameWrapper();
        const singleForm = jsonData[categoryKey][0];
        const replacedSrc = singleForm.src.replace(this.config.placeholderCountryCode, this.config.userCountryCode);
        this.createIFrame(replacedSrc, parentClass);
        this.hideSelect();
        this.setFormContactReason(
          singleForm.reason ? { contactReason: singleForm.reason, nativeLangReason: singleForm.text } : null
        );
      }

      $select.on('change', (e) => {
        const select = e.currentTarget;
        const iframeLink = $(select).val() || '';

        if (iframeLink === 'default') {
          this.setFormContactReason(null);
          return;
        }

        this.emptyIFrameWrapper();
        this.createIFrame(iframeLink, parentClass);

        const selectedOption = select.options[select.selectedIndex];
        this.setFormContactReason({
          contactReason: selectedOption.dataset.reason || '',
          nativeLangReason: selectedOption.textContent.trim(),
        });
      });
    }

    openCategory(event, parentClass) {
      const $categoryLink = $(event.currentTarget);
      const linkHeadline = $categoryLink.data('contact-form-headline') || '';
      const linkSubheadline = $categoryLink.data('contact-form-subheadline') || '';
      const backButtonText = $categoryLink.data('back-button-text') || '';
      const categoryKey = $categoryLink.data('category-id') || '';
      this.setHeadline(linkHeadline);
      this.setSubheadline(linkSubheadline);
      this.hideModalHeadline();
      this.showBackButton(backButtonText);
      this.hideAllCategoryLinks();
      this.populateSelect(categoryKey, parentClass);
      this.scrollToHeadline();
    }

    openCategoryInModal(event) {
      const $target = $(event.target);
      const categoryId = $target.data('contact-form-category-id') || 'idNotFound';
      const $categoryButton = $(`[data-category-id="${categoryId}"]`);
      this.config.disableScrolling = true;

      if (categoryId && $categoryButton.length) {
        $categoryButton.trigger('click');
        this.disableBackButton();
      }
    }

    openCategoryFromQuery() {
      const queryParams = window.location.search.substr(1).split('&');
      const params = this.convertQueryParamsToObject(queryParams);

      if (!params.categoryId) {
        return;
      }

      const $categoryLink = $(`[data-category-id="${params.categoryId}"]`);

      if ($categoryLink.length) {
        const linkHeadline = $categoryLink.data('contact-form-headline') || '';
        const linkSubheadline = $categoryLink.data('contact-form-subheadline') || '';
        const backButtonText = $categoryLink.data('back-button-text') || '';

        this.setHeadline(linkHeadline);
        this.setSubheadline(linkSubheadline);
        this.showBackButton(backButtonText);
        this.hideAllCategoryLinks();
        this.populateSelect(params.categoryId);
      }
    }

    goBack(event) {
      const { contactFormClass } = this.config;
      const formHeadline = $(contactFormClass).data('contact-form-headline') || '';

      event.preventDefault();
      this.setHeadline(formHeadline);
      this.showModalHeadline();
      this.showAllLinks();
      this.hideBackButton();
      this.hideSelect();
      this.emptyIFrameWrapper();
      this.scrollToHeadline();
      this.hideSubheadline();
    }

    // Helper methods
    setHeadline(text) {
      const { headlineClass } = this.config;

      if ($(headlineClass)) {
        $(headlineClass).text(text);
      }
    }

    setSubheadline(text) {
      const { subheadlineClass } = this.config;
      const $subheadline = $(subheadlineClass);

      if ($subheadline) {
        $subheadline.text(text);
        $subheadline.show();
      }
    }

    hideSubheadline() {
      const { subheadlineClass } = this.config;

      $(subheadlineClass).hide();
    }

    scrollToHeadline() {
      const { disableScrolling, headlineClass } = this.config;

      if (disableScrolling) {
        return;
      }

      $([document.documentElement, document.body]).animate({ scrollTop: $(headlineClass).offset().top }, 500);
    }

    setModalHeadline(text) {
      const { modalHeadlineClass } = this.config;

      if ($(modalHeadlineClass)) {
        $(modalHeadlineClass).text(text);
      }
    }

    hideModalHeadline() {
      const { modalHeadlineClass } = this.config;

      if ($(modalHeadlineClass)) {
        $(modalHeadlineClass).hide();
      }
    }

    showModalHeadline() {
      const { modalHeadlineClass } = this.config;

      if ($(modalHeadlineClass)) {
        $(modalHeadlineClass).show();
      }
    }

    showAllLinks() {
      const { linkClass } = this.config;

      $(linkClass).show();
    }

    hideAllCategoryLinks() {
      const { linkClass } = this.config;

      $(linkClass).hide();
    }

    showSelect() {
      const { selectClass } = this.config;

      $(selectClass).show();
    }

    hideSelect() {
      const { selectClass } = this.config;

      $(selectClass).hide();
    }

    createIFrame(link, parentClass) {
      const { iframeClass, iframeWrapperClass } = this.config;
      const $iframe = $('<iframe></iframe>');

      $iframe.addClass(iframeClass.substr(1));
      $iframe.attr('src', link);
      $iframe.attr('frameborder', '0');
      $iframe.attr('scrolling', 'no');
      $iframe.attr('width', '100%');
      $iframe.attr('height', '100%');
      $(`${parentClass} ${iframeWrapperClass}`).prepend($iframe);
      iFrameResize({ log: false, checkOrigin: false }, $iframe.html());

      this.showHorizontalRule();
    }

    emptyIFrameWrapper() {
      const { iframeWrapperClass } = this.config;

      $(iframeWrapperClass).empty();

      this.hideHorizontalRule();
    }

    showHorizontalRule() {
      const { iframeClass } = this.config;
      const $horizontalRule = $(`${iframeClass} + hr`);

      if ($horizontalRule) {
        $horizontalRule.show();
      }
    }

    hideHorizontalRule() {
      const { iframeClass } = this.config;
      const $horizontalRule = $(`${iframeClass} + hr`);

      if ($horizontalRule) {
        $horizontalRule.hide();
      }
    }

    showBackButton(text) {
      const { backButtonClass } = this.config;

      $(backButtonClass).text(text);
      $(backButtonClass).show();
      $(backButtonClass).css('display', 'inline-block');
    }

    hideBackButton() {
      const { backButtonClass } = this.config;

      $(backButtonClass).hide();
    }

    disableBackButton() {
      const { backButtonClass } = this.config;

      $(backButtonClass).removeClass('icon-arrow-outline');
      $(backButtonClass).addClass('pl-4');
      $(backButtonClass).off();
      $(backButtonClass).css('cursor', 'text');
    }

    /*
      Replaces all occurrences of hyphen and letter (e.g. -a)
      and replaces them with just the capitalised letter:
      -a => A
    */
    toCamelCase(kebabCaseString) {
      return kebabCaseString.replace(/-./g, (str) => str.toUpperCase()[1]);
    }

    // Get all query params from the URL, split them and convert them to an object
    convertQueryParamsToObject(queryParams) {
      let params = {};

      queryParams.forEach((queryParam) => {
        let param = queryParam.split('=');

        if (param.length && param.length > 0) {
          const paramObj = {};
          const key = this.toCamelCase(param[0]);

          paramObj[key] = param[1] || '';
          params = { ...params, ...paramObj };
        }
      });

      return params;
    }
  }

  new ContactForm();
})($);
